import { Cart } from '@/core/domain/cart/models/cart-response.model';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CartService {
    private _cart!: Cart | undefined;
    public get cart(): Cart | undefined {
        return this._cart;
    }
    public set cart(v: Cart | undefined) {
        this._cart = v;
    }
}
